import React, { useState } from "react";
import Notiflix from "notiflix";

import {
  Input,
  Row,
  Form,
  Statistic,
  Col,
  Divider,
  Spin,
  Table,
  Typography,
  Select,
  Button,
  Modal,
  Tooltip,
} from "antd";
import {
  PlusOutlined,
  DeleteOutlined,
  PlusCircleOutlined,
} from "@ant-design/icons";
import { BOM } from "../../../../../services/definedMethod";
import cnt from "../../../../../services/definedConstant";
import { apiConfig, labelConfig } from "../../../product.config";
import styles from "../../../../../assets/styles/styles";

const ChargeForm = (props) => {
  //DECLARED VARIABLES
  const {
    onFinish,
    form,
    chargesOptions,
    userData,
    isLoading,
    setIsLoading,
    chargeTableSource,
    setChargeTableSource,
  } = props;
  const { session } = userData;
  const { Title } = Typography;

  // DECLARED VARIABLES FOR CHARRGES FORM
  const [chargeList, setChargeList] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);

const handleChargeDelete = (key) => {
  const newData = chargeTableSource.filter((item) => item.id !== key.id);
  setChargeTableSource(newData);
};


  const columns = [
    {
      title: "Name",
      dataIndex: "name",
    },
    {
      title: "Type",
      dataIndex: "type",
    },
    {
      title: "Amount",
      dataIndex: "amount",
    },
    {
      title: "Collected On",
      dataIndex: "collectedOn",
    },
    {
      title: "Actions",
      dataIndex: "actions",
      render: (_, record) =>
        chargeTableSource.length >= 1 ? (
          <Tooltip title={`Remove Charge`}>
            <Button
              type="primary"
              icon={<DeleteOutlined />}
              onClick={() => handleChargeDelete(record)}
              shape="round"
              size="small"
              className="of-primaryBtnColor"
              style={{backgroundColor:"#BA24D5"}}
            />
          </Tooltip>
        ) : null,
    },
  ];

  return (
    <Form form={form} layout="vertical" onFinish={onFinish}>
      <Divider orientation="left" orientationMargin="0">
        <Title level={5} style={{ margin: 0, marginBottom: 0 }}>
          {labelConfig.chargeInfo}
        </Title>
      </Divider>
      <ChargeModal
        isModalOpen={isModalOpen}
        isLoading={isLoading}
        setIsLoading={setIsLoading}
        setIsModalOpen={setIsModalOpen}
        chargeData={chargesOptions}
        setChargeList={setChargeList}
        setChargeTableSource={setChargeTableSource}
        chargeTableSource={chargeTableSource}
        chargeList={chargeList}
        session={session}
      />

      {chargeTableSource?.length > 0 && (
        <>
          <Divider orientation="left" orientationMargin="0">
            <Title level={5} style={{ margin: 0, marginBottom: 0 }}>
              {chargeTableSource.length > 1
                ? labelConfig.selectedCharges
                : labelConfig.selectedCharge}
            </Title>
          </Divider>
          <Table
            columns={columns}
            dataSource={chargeTableSource}
            bordered
            pagination={{
              position: "bottomCentre",
              pageSize: "10",
            }}
          />
        </>
      )}
    </Form>
  );
};
export default ChargeForm;

const ChargeModal = (props) => {
  const {
    session,
    isLoading,
    setIsLoading,
    setChargeTableSource,
    chargeTableSource,
    isModalOpen,
    chargeData,
    setIsModalOpen,
    setChargeList,
    chargeList,
  } = props;

  const [useForm] = Form.useForm();

  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleOk = () => {
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const handleChargeSave = (formValues) => {
    const newCharges = {
      key: formValues?.chargeId,
      id: formValues?.chargeId,
      name: formValues.name,
      type: formValues.type,
      collectedOn: formValues.collectedOn,
      amountToUse: formValues?.amount,
      amount: (
        <Statistic
          value={formValues?.amount}
          precision={2}
          valueStyle={{ fontSize: "16px" }}
        />
      ),
    };

    // console.log(chargeTableSource);
    let foundCharge = chargeTableSource.find(
      (item) => item.id === newCharges?.id
    );
    if (foundCharge) {
      BOM.AlertMsg(cnt.WARNING, "No duplicate Charge allowed!");
      return;
    }
    setChargeTableSource([...chargeTableSource, newCharges]);

    useForm.resetFields();
  };

  const handleSelectedCharge = (chargeId) => {
    // console.log(chargeId);
    const params = {
      template: "true",
    };

    const url = `${apiConfig.charges}/${chargeId}`;

    const body = {
      session,
      params,
    };

    setIsLoading(true);
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
      } else {
        const objList = res;

        useForm.setFieldsValue({
          key: objList.id,
          id: objList.id,
          name: objList.name,
          type: objList.chargeCalculationType.value,
          collectedOn: objList?.chargeTimeType.value,
          amount: objList?.amount,
        });

        // STOP LOAD
        setIsLoading(false);
      }
    });
  };

  return (
    <Row>
      <Button
        type="primary"
        onClick={showModal}
        icon={<PlusCircleOutlined />}
        shape="round"
        className="of-primaryBtnColor"
        style={{
          backgroundColor: "#BA24D5",
          color: "white",
        //   border: "1px solid #BA24D5",
          borderRadius: 8,
        //   padding: "20px 15px",
          fontSize: "16px",
          fontWeight: "600",
        }}
      >
        {labelConfig.add}
      </Button>

      <Modal
        title="Charge Information Setup"
        open={isModalOpen}
        okText="Add"
        cancelText="Cancel"
        okButtonProps={{
          autoFocus: true,
          htmlType: "submit",
          style: {
            // ...styles.ofPrimaryBtnColor,
                      backgroundColor: "#BA24D5"
          },
        }}
        centered
        onCancel={handleCancel}
        width={800}
        modalRender={(dom) => (
          <Form
            form={useForm}
            layout="vertical"
            onFinish={handleChargeSave}
            name="address-info"
          >
            {dom}
          </Form>
        )}
        style={{
          height: 600,
          overflow: "auto",
        }}
      >
        <Spin spinning={isLoading} tip="Loading..." size="large">
          <Row>
            <Divider />

            <Col span={12} style={{ padding: "0px 8px" }}>
              <Form.Item
                name={"chargeId"}
                label={"Charge Options"}
                rules={[
                  {
                    required: true,
                    message: BOM.CheckReqFld(labelConfig.charge),
                  },
                ]}
              >
                <Select
                  filterOption={(input, option) =>
                    (option?.label?.toLowerCase() ?? "").includes(
                      input?.toLowerCase()
                    )
                  }
                  placeholder={BOM.handlePlaceholderMsg(
                    labelConfig.charge,
                    "select"
                  )}
                  options={chargeData}
                  onChange={handleSelectedCharge}
                  style={{ width: "30vh" }}
                  showSearch
                />
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Divider />
            <Col span={12} style={{ padding: "0px 8px" }}>
              <Form.Item label={labelConfig.name} name={"name"}>
                <Input
                  disabled
                  className="of-bold-disable-input"
                  placeholder={BOM.handlePlaceholderMsg(labelConfig.name)}
                />
              </Form.Item>
            </Col>
            <Col span={12} style={{ padding: "0px 8px" }}>
              <Form.Item label={labelConfig.type} name={"type"}>
                <Input
                  disabled
                  className="of-bold-disable-input"
                  placeholder={BOM.handlePlaceholderMsg(labelConfig.type)}
                />
              </Form.Item>
            </Col>
            <Col span={12} style={{ padding: "0px 8px" }}>
              <Form.Item label={labelConfig.collectedOn} name={"collectedOn"}>
                <Input
                  disabled
                  className="of-bold-disable-input"
                  placeholder={BOM.handlePlaceholderMsg(
                    labelConfig.collectedOn
                  )}
                />
              </Form.Item>
            </Col>
            <Col span={12} style={{ padding: "0px 8px" }}>
              <Form.Item label={labelConfig.amount} name={"amount"}>
                <Input
                  disabled
                  className="of-bold-disable-input"
                  placeholder={BOM.handlePlaceholderMsg(labelConfig.amount)}
                />
              </Form.Item>
            </Col>
          </Row>
        </Spin>
      </Modal>
    </Row>
  );
};
